import axios from 'axios';
import BASE_URL from '../config';
import { getToken, clearAllCookies } from '../../utils/cookies';
import { showSessionExpired } from '../../utils/sessionUtils';

const API = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Flag to prevent multiple toasts
let isShowingExpiredMessage = false;

// Request interceptor to add bearer token
API.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Remove Content-Type header for FormData requests to let browser set it with boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
API.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check for auth errors
    if (error.response?.status === 403 || 
        error.response?.status === 401 ||
        error.response?.data?.detail?.includes('admin access required') ||
        error.response?.data?.detail?.includes('access denied')) {
      
      // Only show toast once
      if (!isShowingExpiredMessage) {
        isShowingExpiredMessage = true;
        
        // Handle expired session
        clearAllCookies();
        
        // Show toast message
        showSessionExpired();
        
        // Redirect to login after a short delay
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
      }
    }
    return Promise.reject(error);
  }
);

export default API;
